import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { getNumber, getRandomColor } from '../../utils/avatar.utils';

interface PixelElementProperties {
  color: string;
}

@Component({
  selector: 'lib-avatar-pixel',
  templateUrl: './avatar-pixel.component.html',
  styleUrl: './avatar-pixel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvatarPixelComponent implements OnInit {
  @Input({ required: true }) colors!: string[];
  @Input({ required: true }) name!: string;
  @Input() inputSize = 40;

  private ELEMENTS = 64;

  SIZE = 80;
  properties: PixelElementProperties[] = [];

  ngOnInit() {
    this.properties = this.generateColors(this.name, this.colors);
  }

  generateColors(name: string, colors: Array<string>): Array<PixelElementProperties> {
    const numFromName = getNumber(name);
    const range = colors && colors.length;

    return Array.from({ length: this.ELEMENTS }, (_, i) => ({
      color: getRandomColor(numFromName % (i + 13), colors, range),
    }));
  }
}
